import React from 'react';
import { Redirect, Route } from 'react-router';
import { Preloader } from '../preloader/Preloader';
import { useIsAuthenticated } from '../../hooks/useIsAuthenticated';
export const LoginRoute = (props) => {
    const { component: Component, redirectTo, loader, ...rest } = props;
    const [isLoading, isAuthenticated] = useIsAuthenticated();
    if (!Component) {
        throw Error('component is undefined');
    }
    const render = (props) => {
        if (isAuthenticated) {
            return React.createElement(Redirect, { to: { pathname: redirectTo } });
        }
        if (isLoading === false)
            return React.createElement(Component, Object.assign({}, props));
        return null;
    };
    return (React.createElement(Preloader, { isLoading: isLoading, loader: loader },
        React.createElement(Route, Object.assign({}, rest, { render: render }))));
};
